import { render, staticRenderFns } from "./Acerca.vue?vue&type=template&id=da63666e&lang=pug"
import script from "./Acerca.vue?vue&type=script&lang=js"
export * from "./Acerca.vue?vue&type=script&lang=js"
import style0 from "./Acerca.vue?vue&type=style&index=0&id=da63666e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports